import { FieldSet, Icon, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { IconTrophyFilled } from '@zillow/constellation-icons';
import { EXTERNAL_WIZARD_OPTIONS } from '../../../constants/stringConstants';

export default function CongratulationsIsYourNewLeaseReady({ onRadioSelect }: { onRadioSelect }) {
  return (
    <>
      <Icon size="lg" role="img" css={{ marginBottom: 'loose' }}>
        <IconTrophyFilled />
      </Icon>
      <FieldSet legend={<Legend>Congratulations! Would you like to create a new lease now?</Legend>}>
        <LabeledControl
          label={<Label>Yes</Label>}
          control={
            <Radio
              name="congratulations-is-your-new-lease-ready"
              onChange={onRadioSelect}
              value={EXTERNAL_WIZARD_OPTIONS.CREATE_LEASE}
            />
          }
        />
        <LabeledControl
          label={<Label>No</Label>}
          control={
            <Radio
              name="congratulations-is-your-new-lease-ready"
              onChange={onRadioSelect}
              value={EXTERNAL_WIZARD_OPTIONS.SEND_TO_PROPERTY_DASHBOARD}
            />
          }
        />
      </FieldSet>
    </>
  );
}
